import {
  operations as rootCauseOperations,
} from '@saucelabs/sl-module-root-cause';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import actions from './actions';
import * as selectors from './selectors';

import { operations } from './index';

export const generalOperations = rootCauseOperations.createRootCauseOperations(actions);

export const getRootCausesForBuild = () => (dispatch, getState) => (
  dispatch(generalOperations.getRootDetail(selectors.buildUserSelector(getState())))
);

export const updateRootCauseForBuild = (params) => (dispatch, getState) => (
  dispatch(actions.updateRootCause({
    ...params,
    ...selectors.buildUserSelector(getState()),
  }, params))
);

export const getRootCauseAnnotationsForBuild = ({ patternId } = {}) => (dispatch, getState) => {
  const rootCauseParams = selectors.buildUserSelector(getState());
  const rootCauseItem = selectors.rootCauseDataSelector(getState(), { patternId });
  return patternId ? dispatch(
    generalOperations.getAnnotations({ patternId, ...rootCauseParams }, patternId, rootCauseItem),
  ) : Promise.resolve();
};

export const getContribution = () => async (dispatch, getState) => {
  const params = selectors.buildUserSelector(getState());
  return dispatch(actions.getContribution(params))
    .catch((error) => {
      dispatch(notificationActions.notifyDanger(
        error.message, 'We\'ve experienced an issue while fetching contribution data.', true,
      ));
    });
};

export const getRootCauseTestsForBuild = ({
  patternId, includeNextToken = false,
} = {}) => (dispatch, getState) => {
  const params = selectors.buildUserSelector(getState());
  const rootCauseItem = selectors.rootCauseDataSelector(getState(), { patternId });
  if (!patternId || !rootCauseItem) {
    return Promise.resolve();
  }

  return dispatch(generalOperations.getTests({
    params: { rootCauseId: patternId, ...params },
    patternId,
    rootCauseItem,
    includeNextToken,
  }));
};

export const getRootCauseAdditionalDataForBuild = (params) => (dispatch, getState) => {
  const { isDataExists } = selectors.rootCauseAdditionalDataSelector(getState(), params);

  return isDataExists ? Promise.resolve() : (
    Promise.all([
      dispatch(operations.getRootCauseAnnotationsForBuild(params)),
      dispatch(operations.getRootCauseTestsForBuild(params)),
    ])
  );
};
